// Browser detection and compatibility utilities
export const getBrowserInfo = () => {
  const userAgent = navigator.userAgent;
  
  // More accurate browser detection
  const isChrome = /Chrome/.test(userAgent) && !/Edg/.test(userAgent) && !/OPR/.test(userAgent);
  const isFirefox = /Firefox/.test(userAgent);
  const isSafari = /Safari/.test(userAgent) && !/Chrome/.test(userAgent) && !/Edg/.test(userAgent);
  const isEdge = /Edg/.test(userAgent);
  const isOpera = /OPR/.test(userAgent) || /Opera/.test(userAgent);
  const isIE = /Trident/.test(userAgent) || /MSIE/.test(userAgent);
  
  return {
    isChrome,
    isFirefox,
    isSafari,
    isEdge,
    isOpera,
    isIE,
    userAgent
  };
};

export const getBrowserCapabilities = () => {
  const browser = getBrowserInfo();
  
  // Check for modern JavaScript features
  const supportsModernJS = (
    'Promise' in window &&
    'fetch' in window &&
    'Symbol' in window &&
    typeof Array.from === 'function' &&
    typeof Object.assign === 'function'
  );
  
  return {
    supportsWebSockets: 'WebSocket' in window,
    supportsMultipleWebSockets: browser.isChrome || browser.isEdge,
    recommendedConnectionDelay: browser.isSafari ? 2000 : browser.isFirefox ? 1500 : 1000,
    maxConcurrentConnections: browser.isSafari ? 2 : browser.isFirefox ? 3 : 5,
    supportsModernJS: supportsModernJS
  };
};

export const getOptimalWebSocketConfig = () => {
  const capabilities = getBrowserCapabilities();
  
  return {
    maxReconnectAttempts: capabilities.maxConcurrentConnections,
    reconnectInterval: capabilities.recommendedConnectionDelay,
    connectionDelay: capabilities.recommendedConnectionDelay,
    heartbeatTimeout: capabilities.isSafari ? 45000 : 60000,
    useSequentialConnections: !capabilities.supportsMultipleWebSockets
  };
};

export const isBrowserSupported = () => {
  const capabilities = getBrowserCapabilities();
  return capabilities.supportsWebSockets && capabilities.supportsModernJS;
};

export const getBrowserWarning = () => {
  const browser = getBrowserInfo();
  const capabilities = getBrowserCapabilities();
  
  // Only show warnings for truly problematic browsers
  if (!capabilities.supportsWebSockets) {
    return 'Your browser does not support WebSockets. Some features may not work properly.';
  }
  
  if (browser.isIE) {
    return 'Internet Explorer is not supported. Please use a modern browser like Chrome, Firefox, or Edge.';
  }
  
  // Only warn for very old browsers (not modern Chrome, Firefox, Safari, Edge)
  if (!capabilities.supportsModernJS) {
    // Check if it's a very old browser version
    const userAgent = navigator.userAgent;
    const isVeryOldChrome = browser.isChrome && !userAgent.includes('Chrome/9');
    const isVeryOldFirefox = browser.isFirefox && !userAgent.includes('Firefox/7');
    const isVeryOldSafari = browser.isSafari && !userAgent.includes('Version/1');
    
    if (isVeryOldChrome || isVeryOldFirefox || isVeryOldSafari) {
      return 'Your browser version is outdated. Some features may not work properly. Please update your browser.';
    }
  }
  
  return null;
};
